import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { initBreakpoints } from 'react-match-breakpoints';
import { ConfigProvider } from 'antd';

import { BREAKPOINTS } from 'app/styles/breakpoints';
import { OrderTrackerPage } from 'app/page/order-tracker-page';
import { i18nAntdLocale } from 'app/i18n';

type Props = RouteComponentProps<void>;

const ReactBreakpoints = initBreakpoints(
    Object.fromEntries(
        Object.entries(BREAKPOINTS)
            .slice(0, -1)
            .map(([key, value]) => [key, `screen and (max-width: ${value - 1}px)`]),
    ),
);

class App extends React.Component<Props> {
    public render(): React.ReactNode {
        return (
            <ConfigProvider locale={i18nAntdLocale}>
                <ReactBreakpoints>
                    <OrderTrackerPage />
                </ReactBreakpoints>
            </ConfigProvider>
        );
    }
}

const AppWithRouter = withRouter(App);

export { AppWithRouter };
